(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initClubfinderMetafieldFilter() {
    const grid = document.querySelector('[ref="grid"]');
    if (!grid) return;

    function parseFilters() {
      const params = new URLSearchParams(window.location.search);
      return {
        merks: params.getAll('filter.p.m.custom.merk'),
        hand: params.get('filter.p.m.custom.handzijde'),
      };
    }

    function ensureEmptyStateEl() {
      let el = grid.parentElement.querySelector('[data-clubfinder-empty-state]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-clubfinder-empty-state', '');
        el.className = 'main-collection-grid__empty';
        el.hidden = true;
        el.innerHTML = '<h2 class="main-collection-grid__empty-title h2">Geen producten gevonden met deze filters.</h2>';
        grid.insertAdjacentElement('afterend', el);
      }
      return el;
    }

    function applyFilters() {
      const { merks, hand } = parseFilters();
      const emptyStateEl = ensureEmptyStateEl();

      if (merks.length === 0 && !hand) {
        emptyStateEl.hidden = true;
        return;
      }

      const items = grid.querySelectorAll('.product-grid__item[data-product-id]');
      let visibleCount = 0;

      items.forEach((item) => {
        const itemMerk = item.dataset.merk || '';
        const itemHand = item.dataset.hand || '';
        const merkMatch = merks.length === 0 || merks.includes(itemMerk);
        const handMatch = !hand || itemHand === hand;
        const show = merkMatch && handMatch;
        item.style.display = show ? '' : 'none';
        if (show) visibleCount += 1;
      });

      grid.hidden = visibleCount === 0;
      emptyStateEl.hidden = visibleCount !== 0;
    }

    applyFilters();

    const observer = new MutationObserver(() => applyFilters());
    observer.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClubfinderMetafieldFilter, { once: true });
  } else {
    initClubfinderMetafieldFilter();
  }

  } catch(e) { console.error(e); }
})();
})();
